<template>
  <side-bar
    v-show="isSidebarActiveLocal"
    position-right
    class="z-10 max-w25 mt-20"
  >
    <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white">ADD PRODUCT</h2>

      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <!-- <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation">
      <b-form role="form" @submit.prevent="handleSubmit(handleSubmitForm)"> -->
    <div class="p-4 mb-8">
      <!-- <h2 class="mb-4 font-semibold text-base">Product Form</h2> -->

      <!-- <ProductForm /> -->

      <div class="mb-4">
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        <img v-if="image" :src="image" ref="cover" />
        <div
          class="text-center text-red cursor-pointer"
          v-if="image"
          @click="handleRemove"
        >
          Remove image
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">
          Product Name<span class="clr-red">*</span>
        </p>
        <b-input
          v-model="name"
          type="text"
          :name="'productName'"
          placeholder="Enter Product Name..."
          @blur="handleName()"
        >
        </b-input>
        <span v-if="nameErr" class="small text-danger">{{ msg.name }}</span>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">
          Product description<span class="clr-red">*</span>
        </p>
        <b-form-textarea
          placeholder="Write Description..."
          v-model="description"
          :name="'description'"
          required
        ></b-form-textarea>
        <span v-if="descErr" class="small text-danger">{{
          "Field is required"
        }}</span>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">
          Brand<span class="clr-red">*</span>
        </p>

        <multiselect
          name="brand"
          v-model="brand"
          :options="brandOptions"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Brand"
          track-by="name"
          label="name"
          :preselect-first="true"
          disabled
        >
        </multiselect>
        <span v-if="brandErr" class="small text-danger">{{
          "Field is required"
        }}</span>
      </div>
      <template>
        <div class="mb-4">
          <p class="font-semibold text-sm mb-2">
            Stock Units<span class="clr-red">*</span>
          </p>
          <b-input
            v-model="sku"
            placeholder="Enter Stock Units..."
            @input="handleSKU"
          />
          <span v-if="skuErr" class="small text-danger">{{ msg.sku }}</span>
        </div>
      </template>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">
          Price<span class="clr-red">*</span>
        </p>
        <b-input
          v-model="price"
          placeholder="Enter Price ..."
          type="number"
          @input="handlePrice"
          required
        />
        <span v-if="priceErr" class="small text-danger">{{ msg.price }}</span>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Discount %</p>
        <b-input
          v-model="discount"
          placeholder="Enter Discount"
          type="number"
          @input="handleDiscount"
        />
        <span v-if="discountErr" class="small text-danger">{{ msg.disc }}</span>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Membership Discounts</p>
        <template v-for="(item, index) in get_all_membership">
          <label>{{ item.name }}</label>
          <b-input
            v-model="memberDisc[item.name]"
            placeholder="Enter Discount"
            type="number"
          />
        </template>
      </div>
    </div>
    <!-- @click.prevent="onSubmit" -->
    <footer class="footer-fix fixed bottom-0 w-1/4">
      <base-button
        @click.prevent="onSubmit"
        block
        type="primary"
        native-type="submit"
        class="rounded-none font-semibold"
        >SUBMIT</base-button
      >
    </footer>
    <!-- </b-form>
    </ValidationObserver> -->
  </side-bar>
</template>

<script>
// import "../../../scss/Index.scss";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import FileUploader from "./FileUploader.vue";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      showcategory: false,
      showproductform: false,
      isURL: false,
      sku: 0,
      name: "",
      description: "",
      url: "",
      brand: "",
      price: 0,
      discount: 0,
      coverImage: null,
      image: null,
      productId: "",
      imageErr: false,
      nameErr: false,
      descErr: false,
      urlErr: false,
      brandErr: false,
      discountErr: false,
      priceErr: false,
      skuErr: false,
      msg: {
        image: "",
        disc: "",
        sku: "",
      },
      memberDisc: {},
      brandOptions: [],
    };
  },
  components: {
    FileUploader,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    ...mapState("auth", ["userData"]),

    ...mapState("affiliate", {
      brandData: "brandData",
      getVendor: "getVendor",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
  },
  methods: {
    handleDiscount(value) {
      if (!/^[0-9]*$/.test(value)) {
        this.discountErr = true;
        this.msg.disc = "Discount is invalid";
      } else if (value < 0 || value >= 100) {
        this.discountErr = true;
        this.msg.disc = "Discount is invalid";
      } else {
        this.discountErr = false;
        const newVal = Number(value.toString());
        this.discount = Math.abs(newVal);
      }
    },
    handlePrice(value) {
      this.priceErr = false;
      if (!/^[0-9]*$/.test(value)) {
        this.priceErr = true;
        this.msg.price = "Price is invalid";
      } else if (value <= 0 || value >= 100000) {
        this.priceErr = true;
        this.msg.price = "Price is invalid";
      } else {
        this.priceErr = false;
        const newVal = Number(value.toString());
        this.price = Math.abs(newVal);
      }
    },
    handleSKU(value) {
      this.skuErr = false;
      if (!/^[0-9]*$/.test(value)) {
        this.skuErr = true;
        this.msg.sku = "Invalid Stock Units";
      } else if (value <= 0 || value > 1000) {
        this.skuErr = true;
        this.msg.sku = "Invalid Stock Units";
      } else {
        this.skuErr = false;
        const newVal = Number(value.toString());
        this.sku = Math.abs(newVal);
      }
    },

    handleName() {
      this.nameErr = false;
      if (!/^[a-zA-Z0-9 ]*$/.test(this.name)) {
        this.nameErr = true;
        this.msg.name = "Name should not be numeric value";
      } else if (this.name.trim() == "") {
        this.nameErr = true;
        this.msg.name = "Name field is required";
      }
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    async onSubmit() {
      let flag = false;
      let keyName = "";
      Object.keys(this.memberDisc).forEach((keys) => {
        if (
          (this.memberDisc[keys] !== null && this.memberDisc[keys] < 0) ||
          this.memberDisc[keys] > 100
        ) {
          flag = true;
          keyName = keys;
        }
      });
      if (flag) {
        this.$swal({
          text: `Enter valid Membership Discounts for ${keyName}`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return;
      }
      // if (this.coverImage === null) {
      //   this.$swal({
      //     text: "Please Add Image",
      //     icon: "error",
      //     showCancelButton: false,
      //     confirmButtonColor: "#830c81",
      //   });
      //   return;
      // }
      this.nameErr = false;
      this.descErr = false;
      this.urlErr = false;
      this.brandErr = false;
      this.priceErr = false;
      this.discountErr = false;
      this.name = this.name.trim();
      this.description = this.description.trim();
      if (this.isURL) this.url = this.url.trim();
      // this.brand = this.brand.trim();
      // this.couponCode = this.couponCode.trim();
      // if (
      //   this.name === "" ||
      //   this.description === "" ||
      //   this.profession === "" ||
      //   this.relate === ""
      // ) {
      //   await this.$swal({
      //     // text: "please add title, description, date and Time",
      //     text: `Please enter all the required details!`,
      //     icon: "warning",
      //     showCancelButton: false,
      //     confirmButtonColor: "#830c81",
      //   });
      //   return;
      // }
      let discountPrice = this.price - (this.price * this.discount) / 100;

      const payload = new FormData();
      payload.append("name", this.name);
      payload.append("description", this.description);
      if (this.isURL === true) {
        payload.append("url", this.url);
        payload.append("isURL", this.isURL);
      } else {
        payload.append("sku", this.sku);
      }
      // payload.append("brand", this.brand);
      payload.append("isVendorProduct", true);
      // if (this.couponCode) payload.append("couponCode", this.couponCode);
      payload.append("price", this.price);
      payload.append("discount", this.discount);
      payload.append("discountPrice", discountPrice);
      if (this.coverImage) payload.append("productImage", this.coverImage);
      if (this.brand) payload.append("brand", JSON.stringify(this.brand));
      payload.append("membershipDisc", JSON.stringify(this.memberDisc));

      let loader;
      try {
        if (this.isURL) {
          if (this.url.trim() == "") {
            await this.$swal({
              text: "URL is required!",
              icon: "warning",
              timer: 1000,
              showConfirmButton: false,
              showCancelButton: false,
            });
            return;
          }
        } else {
          if (this.sku == "") {
            await this.$swal({
              text: "Stock units are required!",
              icon: "warning",
              timer: 1000,
              showConfirmButton: false,
              showCancelButton: false,
            });
            return;
          }
        }
        // console.log(payload);
        loader = this.$loading();
        if (this.name == "") {
          this.nameErr = true;
          this.msg.name = "Name field is required";
        } else if (this.description == "") {
          this.descErr = true;
        } else if (this.brand == "") {
          this.brandErr = true;
        } else if (this.price == "") {
          this.priceErr = true;
          this.msg.price = "Price is invalid";
        }
        //else if (this.discount == "") {
        //  this.discountErr = true;
        //  this.msg.disc = "Field is required";
        //}
        else if (this.discount > 100 || this.discount < 0) {
          this.discountErr = true;
          this.msg.disc = "Enter a valid discount value";
        } else {
          const createProduct = await this.$store.dispatch(
            "affiliate/createProduct",
            payload
          );

          if (createProduct.code === 200) {
            // console.log(createProduct);
            this.getAllProduct();
            loader.close();
            this.closeSideBar();
            await this.$swal({
              title: "Success!",
              text: "Your product has been successfully created!",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });

            this.name = "";
            this.description = "";
            this.url = "";
            // this.brand = "";
            this.sku = 0;
            this.price = 0;
            this.discount = 0;
            this.coverImage = null;
            this.image = null;
          }
        }
        loader.close();
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    getAllProduct() {
      this.$emit("getAllProduct");
    },
    closeSideBar() {
      this.isSidebarActiveLocal = false;
    },
  },
  async mounted() {
    await this.$store.dispatch("affiliate/getVendorById", {
      userId: this.userData._id,
    });
    // console.log(this.getVendor, "****");
    this.brand = this.getVendor.vendor.brandId;
    this.brandOptions = [this.brand];
    await this.get_all_membership.forEach((element, index) => {
      this.memberDisc[element.name] = 0;
    });
  },
};
</script>
